import { useAuth } from "@clerk/clerk-react";
import { useEffect } from "react";

const useClerkToken = () => {
  const { getToken, isSignedIn, isLoaded } = useAuth();

  useEffect(() => {
    const storeToken = async () => {
      if (isLoaded && isSignedIn) {
        try {
          const token = await getToken({ template: "default" });
          if (token) {
            localStorage.setItem("clerkToken", token);
          }
        } catch (err) {
          console.error("Failed to get Clerk token:", err);
        }
      } else if (isLoaded && !isSignedIn) {
        // Clear token when user is not signed in
        localStorage.removeItem("clerkToken");
      }
    };

    storeToken();
  }, [getToken, isSignedIn, isLoaded]);
};

export default useClerkToken;
